const usDollarFormatter = new Intl.NumberFormat("en-US", {
  currency: "USD",
  maximumFractionDigits: 0,
  style: "currency",
});

export const formatDollars = (cents: number) =>
  usDollarFormatter.format(cents / 100);
